import { jsx as _jsx } from "react/jsx-runtime";
import { ConfirmationModal } from 'seagull';
import { useEventReporter, useOverlayContext, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { ServerError } from '~/infra/ErrorResponse';
import { handlePromise, handleRequest } from '~/infra/utils';
import { InvoiceStatus } from '~/models/invoice';
const markAsPaidLoader = 'markAsPaid';
export function shouldShowMarkAsPaid(status, isVendor) {
    if (!isVendor) {
        return false;
    }
    return [
        InvoiceStatus.PaymentStopped,
        InvoiceStatus.PaymentFailed,
        InvoiceStatus.Pending,
        InvoiceStatus.RequiresPaymentApproval,
        InvoiceStatus.PaymentDisputed,
        InvoiceStatus.PaymentActionRequired
    ].includes(status);
}
export async function doMarkAsPaid(param) {
    let { invoiceId, markAsPaidExternally, logBI, startLoader, stopLoader, showErrorToast, reportToHeap, dismissModal, onSuccess, errorMessages } = param;
    logBI(10580);
    reportToHeap('Invoice', 'click', 'mark-as-paid');
    startLoader(markAsPaidLoader);
    const result = await handleRequest(markAsPaidExternally(invoiceId));
    if (result.success) {
        onSuccess && await handlePromise(onSuccess());
        stopLoader(markAsPaidLoader);
        dismissModal(true);
    } else {
        stopLoader(markAsPaidLoader);
        const errorMessage = result.error.hasServerError(ServerError.IncorrectStatusForPaidExternally) ? errorMessages.incorrectStatus : errorMessages.unableToMark;
        showErrorToast(errorMessage);
        dismissModal(false);
    }
}
export function usePaidExternally() {
    const { t: texts } = useLocaleKeys('hooks.paidExternally');
    const { t: commonButtons } = useLocaleKeys('common.buttons');
    const { api, logBI } = useStoreActions();
    const { startLoader, stopLoader, showErrorToast, showModal } = useOverlayContext();
    const { reportToHeap } = useEventReporter();
    function markAsPaid(invoice, onSuccess) {
        return showModal({
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            openBottomSheetOnMobile: true,
            hideBottomSheetOnDismiss: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ConfirmationModal, {
                    title: texts.title(),
                    content: texts.content(),
                    testId: "mark-as-paid-confirmation-modal",
                    primaryButtonLabel: texts.markAsPaid(),
                    secondaryButtonLabel: commonButtons.cancel(),
                    onSecondaryButtonClick: ()=>dismissModal(false),
                    onCloseButtonClick: ()=>dismissModal(false),
                    onPrimaryButtonClick: ()=>doMarkAsPaid({
                            invoiceId: invoice.id,
                            markAsPaidExternally: api.invoice.markAsPaidExternally,
                            logBI,
                            startLoader,
                            stopLoader,
                            showErrorToast,
                            reportToHeap,
                            dismissModal,
                            onSuccess,
                            errorMessages: {
                                incorrectStatus: texts.incorrectStatusError(),
                                unableToMark: texts.unableToMarkError()
                            }
                        })
                });
            }
        });
    }
    return {
        markAsPaid,
        shouldShowMarkAsPaid
    };
}
